import { http } from '@/providers/apis/http';
import { learningRegistrySerializer } from '@/providers/serializers/learning-registry/learning-registry';

export class LearningRegistryAPI {

  private static INSTANCE = new LearningRegistryAPI();

  private namespace = 'api/learning-registry/v1';

  static get instance() {
    return this.INSTANCE;
  }

  public getToolProviderList(categoryList: any): Promise<any[]> {
    const endpoint = `${this.namespace}/provider/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return learningRegistrySerializer.serializeToolProviderList(response.data, categoryList);
    });
  }

  public saveToolProviderInfo(provider: any): Promise<any[]> {
    const endpoint = `${this.namespace}/tool/provider`;
    const headers = http.getTokenHeaders();
    const providerInfo = learningRegistrySerializer.normalizeProviderInfo(provider);
    return http.post(endpoint, headers, providerInfo).then((response) => {
      const resp: any = response;
      return resp.headers.location;
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public saveToolsToProvider(tool: any): Promise<any[]> {
    const endpoint = `${this.namespace}/provider/tool`;
    const headers = http.getTokenHeaders();
    const toolData = learningRegistrySerializer.normalizeToolData(tool);
    return http.post(endpoint, headers, toolData).then((response) => {
      return response.data;
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public updateToolsToProvider(tool: any, id: any): Promise<any[]> {
    const endpoint = `${this.namespace}/learning-tools/${id}`;
    const headers = http.getTokenHeaders();
    const toolData = learningRegistrySerializer.normalizeToolData(tool);
    return http.put(endpoint, headers, toolData).then((response) => {
      return response.data;
    });
  }

  public fetchRegistryList() {
    const endpoint = `${window.location.origin}/stubs/registry.json`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public fetchProviderList() {
    const endpoint = `${this.namespace}/tool/registry/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return learningRegistrySerializer.serializeProviderList(response.data);
    });
  }

  public fetchToolRegistryList(params: any) {
    const endpoint = `${this.namespace}/tool/registry/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return learningRegistrySerializer.serializeToolRegistryList(response.data);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public fetchContentProviderList(params: any) {
    const endpoint = `${this.namespace}/content/registry/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return learningRegistrySerializer.serializeContentProviderList(response.data);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public fetchSubscribedToolRegistryList(params: any) {
    const endpoint = `${this.namespace}/subscribed/learning-tools`;
    const headers: any = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return learningRegistrySerializer.serializeSubscribeToolRegistryList(response.data, params.registry_type);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public fetchTooList() {
    const endpoint = `${this.namespace}/tools/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return learningRegistrySerializer.serializeDropDownToolList(response.data);
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public savePublisher(publisherInfo: any): Promise<any[]> {
    const endpoint = `${this.namespace}/publishers`;
    const headers = http.getTokenHeaders();
    const publisherData = learningRegistrySerializer.serializePublisherInfo(publisherInfo);
    return http.post(endpoint, headers, publisherData).then((response) => {
      return response.data;
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public updateProductInfo(publisherInfo: any): Promise<any[]> {
    const endpoint = `${this.namespace}/publishers/${publisherInfo.id}`;
    const headers = http.getTokenHeaders();
    const publisherData = learningRegistrySerializer.serializePublisherInfo(publisherInfo);
    return http.put(endpoint, headers, publisherData).then((response) => {
      return response.data;
    }).catch((error: any) => {
      return { message: 'error' };
    });
  }

  public saveToolDataInInfo(toolId: any, dataSelection: any): Promise<any[]> {
    const endpoint = `${this.namespace}/tool/data-in/${toolId}`;
    const headers = http.getTokenHeaders();
    return http.post(endpoint, headers, dataSelection).then((response) => {
      return response.data;
    });
  }

  public configureToolInfo(toolData: any): Promise<any[]> {
    const configData = learningRegistrySerializer.serializeConfigTool(toolData);
    const endpoint = `${this.namespace}/subscribed/tool/configure`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, configData).then((response) => {
      return response.data;
    });
  }
}

export const learningRegistryAPI = LearningRegistryAPI.instance;
